import * as Types from '@mildang/graphql-artifact';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RegisterFcmTokenMutationVariables = Types.Exact<{
  input: Types.RegisterFcmTokenInput;
}>;


export type RegisterFcmTokenMutation = { __typename?: 'Mutation', registerFcmToken: { __typename?: 'RegisterFcmTokenPayload', fcmToken: { __typename?: 'FcmToken', deviceId: string, deviceType: Types.DeviceType, token: string, userId: string } } };


export const RegisterFcmTokenDocument = gql`
    mutation registerFcmToken($input: RegisterFcmTokenInput!) {
  registerFcmToken(input: $input) {
    fcmToken {
      deviceId
      deviceType
      token
      userId
    }
  }
}
    `;
export type RegisterFcmTokenMutationFn = Apollo.MutationFunction<RegisterFcmTokenMutation, RegisterFcmTokenMutationVariables>;

/**
 * __useRegisterFcmTokenMutation__
 *
 * To run a mutation, you first call `useRegisterFcmTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterFcmTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerFcmTokenMutation, { data, loading, error }] = useRegisterFcmTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterFcmTokenMutation(baseOptions?: Apollo.MutationHookOptions<RegisterFcmTokenMutation, RegisterFcmTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterFcmTokenMutation, RegisterFcmTokenMutationVariables>(RegisterFcmTokenDocument, options);
      }
export type RegisterFcmTokenMutationHookResult = ReturnType<typeof useRegisterFcmTokenMutation>;
export type RegisterFcmTokenMutationResult = Apollo.MutationResult<RegisterFcmTokenMutation>;
export type RegisterFcmTokenMutationOptions = Apollo.BaseMutationOptions<RegisterFcmTokenMutation, RegisterFcmTokenMutationVariables>;
export const namedOperations = {
  Mutation: {
    registerFcmToken: 'registerFcmToken'
  }
}